// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import assistantEntity from './entities/assistant.json';
import assistantMenu from '../pages/assistant/menu.json';
import assistantFullForm from '../pages/assistant/forms/full.json';
import assistantContextForm from '../pages/assistant/forms/context.json';
import assistantMiniForm from '../pages/assistant/forms/mini.json';
import assistantLookupForm from '../pages/assistant/forms/lookup.json';
import assistantTableView from '../pages/assistant/views/table.json';
import assistantStagesView from '../pages/assistant/views/stages.json';
import assistantCardsView from '../pages/assistant/views/cards.json';
import assistantInlineView from '../pages/assistant/views/inline.json';
import assistantBacklogView from '../pages/assistant/views/backlog.json';
import assistantSplitView from '../pages/assistant/views/split.json';
import assistantCalendarView from '../pages/assistant/views/calendar.json';
import assistantDashboardView from '../pages/assistant/views/dashboard.json';

/** Тип запису «Помічник» зі сторінками пакета: меню, форми та подання з pages/assistant/. */
export const assistantDefinition: IRecordTypeDefinition = {
  ...assistantEntity,
  views: assembleViewSet({
      table: assistantTableView,
      stages: assistantStagesView,
      cards: assistantCardsView,
      inline: assistantInlineView,
      backlog: assistantBacklogView,
      split: assistantSplitView,
      calendar: assistantCalendarView,
      dashboard: assistantDashboardView,
  }),
  form: assistantFullForm,
  forms: { full: assistantFullForm, context: assistantContextForm, mini: assistantMiniForm, lookup: assistantLookupForm },
  menu: assistantMenu,
} as IRecordTypeDefinition;
